import { WebchatAction } from '@pwp-common';

export const sendWebchatAction = (action: WebchatAction): void => {
  window.parent.postMessage(action, '*');
};
